import { render, staticRenderFns } from "./FrmOCheck.vue?vue&type=template&id=9d5cc242&scoped=true"
import script from "./FrmOCheck.vue?vue&type=script&lang=js"
export * from "./FrmOCheck.vue?vue&type=script&lang=js"
import style0 from "./FrmOCheck.vue?vue&type=style&index=0&id=9d5cc242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5cc242",
  null
  
)

export default component.exports